/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Source_NoteInputs */

const en_pc_dl_source_note = /** @type {(inputs: Pc_Dl_Source_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every download button on this page takes you to`)
};

const zh_pc_dl_source_note = /** @type {(inputs: Pc_Dl_Source_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本页的每个下载按钮都会跳转到`)
};

/**
* | output |
* | --- |
* | "Every download button on this page takes you to" |
*
* @param {Pc_Dl_Source_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_source_note = /** @type {((inputs?: Pc_Dl_Source_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Source_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_source_note(inputs)
	return zh_pc_dl_source_note(inputs)
});
export { pc_dl_source_note as "pc.dl.source_note" }